<template>
    <div>
        <div class="nrk company">
            <p class="litext">吉林医药设计院有限公司（以下简称吉林医药设计院）创建于1986年，民营企业,中国医药工程设计协会副会长单位，吉林省勘察设计行业AAA级信用企业。拥有一批经验丰富的优秀工程设计人员，包括设计大师和获政府津贴的专家、执业注册人员及正、副高级职称人员，各类工程技术人员占员工总数的90%以上。</p>
            <img src="../img/xt-1.jpg" class="litext-text">
                <!--公司简介-->
        </div>
        <div class="course nark">
            <div class="course-nr">
                <ul class="course-text">
                    <li>
                        <div><i>{{figure1}}</i><p>+</p></div>
                        <span class="wow animate__animated animate__bounce">25年发展历程</span>
                    </li>
                    <li>
                        <div><i>{{figure2}}</i><p>+</p></div>
                        <span class="wow animate__animated animate__bounce" data-wow-delay="0.3s">40多项奖项</span>
                    </li>
                    <li>
                        <div><i>{{figure3}}</i><p>+</p></div>
                        <span class="wow animate__animated animate__bounce" data-wow-delay="0.6s">1000余家优质客户</span>
                    </li>
                    <li>
                        <div><p>+</p><i>{{figure4}}</i></div>
                        <span class="wow animate__animated animate__bounce" data-wow-delay="0.9s">4700多个项目</span>
                    </li>   
                </ul>
            </div>
        </div>
        <div class="nrk liesc">
            <div v-for="(item,index) in study" :key="index">
                <div class="letr">
                    <img :src="n+(index+1)+'.jpg'">
                    <p>{{item.name}}</p>
                </div>
                <div class="rlis"><span>{{item.text}}</span></div>
            </div>
        </div>
    </div>
    
</template>

<script>
import {mapState} from "vuex"
export default {
    data() {
        return {
            figure1: 37,
            figure2: 40,
            figure3: 1000,
            figure4: 4700,
            faiked: false,
            liedn: 0,
            linq: 0,
            data:{
                type:2
            },
            n:'./img/n-'
        }
        
    },
    mounted() {
        this.$store.dispatch('PostAbout',this.data);
    },
    computed:{
		...mapState({
			study:state=>state.share.study,
            About:state=>state.share.About
		})
        
	},
}
</script>

<style scoped>
    .company{
        margin: 2% auto;
        overflow: hidden;
    }
    .litext{
        width: 60%;
        float: left;
        padding-top: 1%;
        font-size: 22px;
        line-height: 50px;
        text-align: justify;
        text-indent: 2em;
    }
    .litext-text{
        width: 36%;
        float: right;
    }
    .course {
        width: 100%;
        background: url(../img/beij_2.jpg) no-repeat center center;
        overflow: hidden;
        margin-top: 90px;
    }

    .course-nr {
        width: 1435px;
        margin: 0 auto;
        margin-top: 60px;
        margin-bottom: 60px;
    }

    .course-text {
        width: 100%;
        overflow: hidden;
    }

    .course-text li {
        float: left;
        width: 25%;
    }
    .course-text li:nth-child(2){
        text-align: center;
    }
    .course-text li:nth-child(2) i{
        margin-left:120px;
    }
    .course-text li:nth-child(3){
        text-align: center;
    }
    .course-text li:nth-child(3) i{
        margin-left:60px;
    }
    .course-text li:last-child{
        text-align: right;
    }
    .course-text li:last-child span{
        text-align: right;
        margin-right: 37px;
    }
    .course-text li:last-child i{
        float: right;
    }
    .course-text li:last-child p{
        float: right;
    }
    .course-text li>div{
        font-size: 76px;
        color: #fff;
        font-weight: bold;
        overflow: hidden;
    }

    .course-text li p {
        font-size: 50px;
        float: left;
    }

    .course-text span {
        font-size: 28px;
        margin-top: 30px;
        color: #fff;
        display: block;
    }

    .course-text li>div i {
        float: left;
    }
    .course-bottom-text {
        font-size: 26px;
        margin-top: 70px;
        color: #fff;
        text-align: justify;
        line-height: 50px;
        margin-bottom: 200px;
    }
    .liesc{
        margin-top: 40px;
        overflow: hidden;
    }
    .liesc>div{
        width: 43%;
        float: left;
        margin-right: 4%;
        border: 1px #eee solid;
        border-radius: 15px;
        padding: 1% 2%;
        margin-bottom: 24px;
    }
    .liesc>div:nth-child(2n){
        margin-right: 0%;
    }
    .letr{
        width: 26%;
        border-right: 1px #eee solid;
        float: left;
        margin-top: 10px;
    }
    .letr img{
        width: 60%;
        margin: 0 auto;
        display: block;
    }
    .letr p{
        text-align:center;
        font-size: 16px;
        font-weight: bold;
        margin-top: 6px;
    }
    .liesc .rlis{
        width: 67%;
        float: right;
        font-size: 14px;
        text-align: justify;
        display: flex;
        align-items:center;
        justify-content: space-between;
        height: 140px;
        overflow: hidden;
        text-indent: 2em;
    }
    .liesc .rlis span{
        display: block;

    }
    @media (max-width: 768px){
        .liesc .rlis{
            height: auto;
            padding: 16px 0;
        }
        .copyright{
            margin-top: 20px;
        }
        .bottomNavigation{
            display: none;
        }
        .copyright-title img{
            position:unset;
            margin:0 auto;
            display: block;
            margin-top: 20px;
        }
        .copyright-title span{
            display: block;
            margin: 0 auto;
            margin-top: 12px;
        }
        .litext{
            width: 100%;
            font-size: 14px;
            line-height: 30px;
        }
        .litext-text {
            width: 100%;
        }
        .liesc>div{
            width: 95%;
        }
        .liesc .rlis{
            font-size: 13px;
        }
        .liesc .rlis{
            width: 70%;
        }
        .liesc .rlis span{
            width: 96%;
        }
        .letr{
            margin-top: 25px;
        }
        .liesc:nth-child(2) div .rlis{
            height: 200px;
        }
        .course{
            margin-top: 40px;
        }
    }
    @media (max-width: 768px){
        .course-bottom-text {
            font-size: 14px;
            margin-top: 4px;
            line-height:26px;
            margin-bottom: 20px;
        }
        .course-text span{
            font-size: 14px;
            text-align: center;
            margin-top: 12px;
        }
        .course-text li{
            width: 50%;
            margin-bottom: 20px;
        }
        .course-text li>div{
            font-size: 40px;
            display: flex;
            justify-content: center;
        }
        .course-text li:nth-child(2) i{
            margin-left: 16px;
        }
        .course-text li p{
            font-size: 24px;
        }
        .course-text li:nth-child(3) i{
            margin-left: 12px;
        }
        .course-nr{
            margin-top: 40px;
            width: auto;
            margin-bottom: 20px;
        }
    }
</style>